import {sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {branches$, fetchBranchesFx, Gate} from './index';

branches$.on(fetchBranchesFx.doneData, (_, branches) => branches).reset(Gate.close);

sample({clock: Gate.open, target: fetchBranchesFx});

fetchBranchesFx.failData.watch((error) => showRestError(error as RestError));
